export default __webpack_public_path__ + "static/media/mlm.ebbc8623.svg";